import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-integration',
    templateUrl: './breadcrumb.integration.component.html'
})

export class BreadcrumbIntegrationComponent {
    @Input() companyId: number;

    roleMatrix: RoleMatrix;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
